import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Button, Container, Drawer } from '@material-ui/core';
import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

//app
import UserMenu from 'components/UserMenu';
import { ROUTE_LOG_IN } from 'routes/routes';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import useMobile from 'utils/useMobile';
import LogoAppBar from 'components/Logo/LogoAppBar';
import LogoSidebar from 'components/Logo/LogoSidebar';
import AppBarNavList from './Nav/AppBarNavList';
import membersNavData from './Nav/membersNavData';
import SidebarNavList from './Nav/SidebarNavList';
import landingNavData from './Nav/landingNavData';
import useAuthUser from 'components/Session/useAuthUser';

const useStyles = makeStyles(({ spacing, breakpoints, mixins }) => ({
  toolbar: {
    alignItems: 'center'
  },
  navItems: {
    justifyContent: 'space-between',
    flexGrow: 1
  },
  sidebar: {
    width: 240
  },
  grow: {
    flexGrow: 1
  },
  container: {
    paddingLeft: 0,
    paddingRight: 0
  },
  appBar: {
    paddingRight: '0 !important' //wierd issue with material menu adding padding
  }
}));

const MainAppBar = () => {
  const authUser = useAuthUser();
  const [showLoading, setShowLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  setTimeout(() => setShowLoading(true), 500);
  const classes = useStyles({})
;
  const isMobile = useMobile();
  const onSideBarNavClicked = () => {
    setTimeout(() => setSidebarOpen(false), 250);
  };

  const isAuthenticated = !!authUser;
  const isNotAuthenticated = authUser === null;
  const isAuthenticating = authUser === undefined;
  return (
    <>
      <AppBar className={classes.appBar} position="fixed" color="default">
        <Container maxWidth="lg" className={classes.container}>
          <Toolbar className={classes.toolbar}>
            {isMobile && (
              <IconButton edge="start" onClick={() => setSidebarOpen(true)} color="inherit" aria-label="Menu">
                <MenuIcon />
              </IconButton>
            )}
            <LogoAppBar />

            {isAuthenticated && (
              <>
                {!isMobile && <AppBarNavList navItems={membersNavData} />}
                <div className={classes.grow} />
                <UserMenu authUser={authUser} />
              </>
            )}
            {isNotAuthenticated && (
              <>
                {!isMobile && <AppBarNavList navItems={landingNavData} />}
                <div className={classes.grow} />
                <Button color="inherit" component={Link} to={ROUTE_LOG_IN}>
                  Login
                </Button>
              </>
            )}
          </Toolbar>
        </Container>

        {isAuthenticating && showLoading ? <LinearProgress color="primary" /> : null}
      </AppBar>
      <Drawer open={sidebarOpen} onClose={onSideBarNavClicked}>
        <div className={classes.sidebar} role="presentation" onKeyDown={onSideBarNavClicked}>
          <LogoSidebar />
          {isNotAuthenticated && <SidebarNavList navItems={landingNavData} onNavClicked={onSideBarNavClicked} />}
          {isAuthenticated && <SidebarNavList navItems={membersNavData} onNavClicked={onSideBarNavClicked} />}
        </div>
      </Drawer>
    </>
  );
};
export default MainAppBar;
